import './FormGroup.scss'

import classNames from 'classnames'
import React, { forwardRef, HTMLProps, ReactNode, RefObject } from 'react'

export interface InputProps extends HTMLProps<HTMLInputElement> {
  className?: string
  label?: string
  type?: string
  notBlank?: boolean
  error?: boolean
}

export interface SelectProps extends HTMLProps<HTMLSelectElement> {
  children: ReactNode
  className?: string
  label?: string
}

export interface TextareaProps extends HTMLProps<HTMLTextAreaElement> {
  className?: string
  label?: string
}

const Input = forwardRef((props: InputProps, ref: RefObject<HTMLInputElement>) => {
  const { className, label = null, type = 'text', notBlank, required, error, ...otherProps } = props

  const isRequired = required || notBlank
  const pattern = notBlank ? '.*\\S+.*' : undefined

  const isCheckbox = type === 'checkbox'
  const mergedClassName = classNames('form-group', className, {
    'form-group--checkbox': isCheckbox,
    'form-group--error': error
  })

  return (
    <label className={mergedClassName}>
      {!isCheckbox && label}
      <input type={type} ref={ref} required={isRequired} pattern={pattern} {...otherProps} />
      {isCheckbox && label}
    </label>
  )
})
Input.displayName = 'FormGroup.Input'

const Textarea = forwardRef((props: TextareaProps, ref: RefObject<HTMLTextAreaElement>) => {
  const { className, label = null, ...otherProps } = props
  const mergedClassName = classNames('form-group', className)

  return (
    <label className={mergedClassName}>
      {label}
      <textarea ref={ref} {...otherProps} />
    </label>
  )
})
Textarea.displayName = 'FormGroup.Textarea'

const Select = forwardRef((props: SelectProps, ref: RefObject<HTMLSelectElement>) => {
  const { children, className, label = null, ...otherProps } = props
  const mergedClassName = classNames('form-group--select', className)

  return (
    <label className={mergedClassName}>
      {label}
      <select ref={ref} {...otherProps}>
        {children}
      </select>
    </label>
  )
})
Select.displayName = 'FormGroup.Select'

export default class FormGroup {
  public static Input = Input
  public static Textarea = Textarea
  public static Select = Select
}
